module.exports = __webpack_public_path__ + "img/pic.1b10d0ba.png";